(function (module) {
    "use strict";

    module.service('pmForecastService', ['synchronousEventsBus', 'dtpChartService', 'PPGChartAndTableService', 'correctionAboutFactsService', function(
        this: $TSFixMe,
        synchronousEventsBus: $TSFixMe,
        dtpChartService: $TSFixMe,
        PPGChartAndTableService: $TSFixMe,
        correctionAboutFactsService: $TSFixMe
    ) {
        var service = this;

        service.registerEvents = function () {
            synchronousEventsBus.$on('freezedMonthCalculated', function (e: $TSFixMe, args: $TSFixMe) {
                args.forecast.pmForecast = correctionAboutFactsService.reclaculate(
                    args.forecast.freezedMonthForecast,
                    args.parameters,

                    angular._get(args, 'forecast.correction', []),

                    angular._get(args, 'forecast.freezedMonths', 0));
                return synchronousEventsBus.$broadcast('pmForecastChanged', { forecast: args.forecast, parameters: args.parameters });
            });
        }

        service.removeCorrect = function (start: $TSFixMe, end: $TSFixMe, forecast: $TSFixMe, parameters: $TSFixMe) {
            forecast.pmForecast = correctionAboutFactsService.removeCorrection(forecast.freezedMonthForecast, parameters, forecast.correction, start, end);
            return synchronousEventsBus.$broadcast('pmForecastChanged', { forecast: forecast, parameters: parameters });
        };

        service.updateCorrect = function (correctionFact: $TSFixMe, forecast: $TSFixMe, parameters: $TSFixMe) {
            if (!forecast.correction) {
                forecast.correction = [];
            }
            forecast.pmForecast = correctionAboutFactsService.addOrUpdateCorrection(forecast.freezedMonthForecast, parameters, forecast.correction, correctionFact);
            return synchronousEventsBus.$broadcast('pmForecastChanged', { forecast: forecast, parameters: parameters });
        };

        service.recalculateMonthsChanged = function (forecast: $TSFixMe, parameters: $TSFixMe) {
            const corectedPmForecast = correctionAboutFactsService.reclaculate(
                forecast.freezedMonthForecast,
                parameters,
                forecast.correction,
                forecast.freezedMonths).slice(forecast.freezedMonths);

            forecast.pmForecast = forecast.freezedMonthsVolume.concat(corectedPmForecast);

            return synchronousEventsBus.$broadcast('pmForecastChanged', { forecast: forecast, parameters: parameters });
        }
    }]);

    module.run(['pmForecastService', (service: $TSFixMe) => { service.registerEvents(); }]);

})(angular.module('topline.services'));